<template>
  <v-container fluid :class="`${$vuetify.breakpoint.smAndUp?'mx-4':'pl-7'} accounts-wrapper`">
    <h2 class="mt-5">Account &amp; Billing</h2>
    <div >
      <v-tabs
        height="50px"
        class="mt-5 accounts-tabs"
        color="#03b6fc"
        v-model="activeTab"          
      >
        <v-tab  v-for="tab in  accountSettingsTabs" :key="tab.id" :to="tab.route" exact class="accounts-tab" 
          v-track="tab.uniqueId" :id="tab.uniqueId">
          <span
            class="ml-1 body-2 font-weight-regular"
          >
            {{ tab.name }}
          </span>
        </v-tab>
      </v-tabs>
    </div>
    <router-view />
  </v-container>
</template>
<script>
import { $users } from "@core/services";
import { mapGetters } from 'vuex'

import constants, { ROUTE_PREFIX } from "@core/config/constants.js";
const { MAROPOST_PRODUCTS } = constants;

export default {
  name: 'Accounts',
  data () {
    return {
      activeTab: `${ROUTE_PREFIX}/${this.accountId}/account-&-billing`,
    }
  },
  computed: {
    ...mapGetters({ 
      accountId : 'auth/account.id',
      currentAccount: "auth/account.current",
    }),
    accountSettingsTabs(){
      let product = this.hasMarketingAccess? MAROPOST_PRODUCTS.marketingCloud : MAROPOST_PRODUCTS.serviceCloud
      if(this.$route.query.product){
        product = this.$route.query.product
      }
      return [
        { 
          id: 1, 
          uniqueId: "overview-tab", 
          name: "Overview", 
          route: `${ROUTE_PREFIX}/${this.accountId}/account-&-billing/`
        },
        { 
          id: 2, 
          uniqueId: "account-tab", 
          name: "Company Information", 
          route: `${ROUTE_PREFIX}/${this.accountId}/account-&-billing/company-information` 
        },
        { 
          id: 3, 
          uniqueId: "usage-tab", 
          name: "usage", 
          route: `${ROUTE_PREFIX}/${this.accountId}/account-&-billing/usage?product=${product}` 
        }
      ]
    },
    hasMarketingAccess(){
      return this.currentAccount.enable_marketing;
    },
  },
  mounted(){
    /*
    * Following dispatch method call would be removed on user settings completion
    */
    if(this.hasMarketingAccess){
      this.$store.dispatch("auth/getPackageFeatures");
    }
    $users.getRoles().then(response => {
      this.$store.commit('auth/roles', response.data.data.roles)
    }).catch(error => {
      console.log('error', error)
    })
  }, 
}
</script>
<style lang="scss">
.accounts-wrapper{
  max-width: 100vw;
}
.accounts-wrapper{
  .v-tabs > .v-slide-group__next--disabled, .v-slide-group__prev--disabled{
    display:none !important;
  }
  .v-tabs > .v-tabs-bar{
    background-color: #fafafa !important;
  }
  .accounts-tabs .v-tab{
    padding:0px 32px;
  }
  .v-tabs-items{
    background-color: #fafafa !important;
  }
  .v-tabs > .v-tabs-bar {
    border-bottom: 1px solid #D5D5D5;
  }
}
</style>